export const AcceptFileFormat = [
    "image/jpg", 
    "image/jpeg", 
    "application/pdf"
];
